var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.5,
    height: 28,
    role: "img",
    "aria-label": "EXPRESS.JS",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EXPRESS.JS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.5,
    height: 28,
    fill: "#000000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkV4cHJlc3M8L3RpdGxlPjxwYXRoIGQ9Ik0yNCAxOC41ODhhMS41MjkgMS41MjkgMCAwMS0xLjg5NS0uNzJsLTMuNDUtNC43NzEtLjUtLjY2Ny00LjAwMyA1LjQ0NGExLjQ2NiAxLjQ2NiAwIDAxLTEuODAyLjcwOGw1LjE1OC02LjkyLTQuNzk4LTYuMjUxYTEuNTk1IDEuNTk1IDAgMDExLjkuNjY2bDMuNTc2IDQuODMgMy41OTYtNC44MWExLjQzNSAxLjQzNSAwIDAxMS43ODgtLjY2OEwyMS43MDggNy45bC0yLjUyMiAzLjI4M2EuNjY2LjY2NiAwIDAwMCAuOTk0bDQuODA0IDYuNDEyek0uMDAyIDExLjU3NmwuNDItMi4wNzVjMS4xNTQtNC4xMDMgNS44NTgtNS44MSA5LjA5NC0zLjI3IDEuODk1IDEuNDg5IDIuMzY4IDMuNTk3IDIuMjc1IDUuOTczSDEuMTE2Qy45NDMgMTYuNDQ3IDQuMDA1IDE5LjAwOSA3LjkyIDE3LjdhNC4wNzggNC4wNzggMCAwMDIuNTgyLTIuODc2Yy4yMDctLjY2Ni41NDgtLjc4IDEuMTc0LS41ODhhNS40MTcgNS40MTcgMCAwMS0yLjU4OSAzLjk1NyA2LjI3MiA2LjI3MiAwIDAxLTcuMzA2LS45MzMgNi41NzUgNi41NzUgMCAwMS0xLjY0LTMuODU4YzAtLjIzNS0uMDgtLjQ1NS0uMTM0LS42NjZBODguMzMgODguMzMgMCAwMTAgMTEuNTc3em0xLjEyNy0uMjg2aDkuNjU0Yy0uMDYtMy4wNzYtMi4wMDEtNS4yNTgtNC41OS01LjI3OC0yLjg4Mi0uMDQtNC45NDQgMi4wOTQtNS4wNzEgNS4yNjR6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 712.5,
    y: 175,
    textLength: 785,
    fill: "#fff",
    fontWeight: "bold"
  }, "EXPRESS.JS"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.06cb6463caaf6d59e4753312b900c775.svg";
export { ForwardRef as ReactComponent };